import {MimeTypeMap} from "./mime_types";

export class Debouncer {

  private timer: any;

  constructor(readonly timeout: number = 1000) {
  }

  run(fn: () => void) {
    clearTimeout(this.timer);
    this.timer = setTimeout(fn, this.timeout);
  }
}

export class FileUtil {

  static nameFromFile(file: File): string {
    return this.nameFromFileName(file.name);
  }

  static nameFromFileName(name: string): string {
    const index = name.lastIndexOf(".");
    if (index >= 0 && MimeTypeMap.getInstance().hasExtension((name.substring(index + 1)))) {
      return name.substring(0, index);
    }
    return name;
  }

  static extensionFromFile(file: File): string {
    return this.extensionFromFileName(file.name);
  }

  static extensionFromFileName(name: string): string {
    const index = name.lastIndexOf(".");
    let ext: string;
    if (index >= 0 && MimeTypeMap.getInstance().hasExtension((ext = name.substring(index + 1)))) {
      return ext;
    }
    return null;
  }

  static async resizeImage(blob: Blob, maxWidth: number, maxHeight: number): Promise<Blob> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(blob);

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // Calculate new dimensions while maintaining aspect ratio
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob((resizedBlob) => {
          resolve(resizedBlob);
        }, 'image/jpeg', 0.8); // Adjust quality as needed
      };
    });
  }
}